import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { TranslateFunction } from 'react-localize-redux';

import {
  PriceTag,
  SectionItem,
  Typography,
} from '../../../../../components/atoms';
import { Currency } from '../../../../../core/api/general/general.types';
import { formatNumberToCurrency } from '../../../../../utils/basketUtils';

type Props = {
  balanceOutstanding: number;
  currency: Currency;
  currentLang: string;
  translate: TranslateFunction;
};

const useStyles = makeStyles((theme: Theme) => ({
  balanceSection: {
    borderTop: 'none',
  },

  balanceTotal: {
    '& .fd-text': {
      fontSize: theme.typography.pxToRem(24),

      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(21),
      },
    },
  },

  balanceHelperText: {
    color: theme.palette.warning.main,
    width: 'calc(100% - 96px)',
  },
}));

export function BalanceOutstanding(props: Props): JSX.Element {
  const classes = useStyles();
  const { balanceOutstanding, currency, currentLang, translate } = props;

  const isSupplementaryPaymentRequired = balanceOutstanding > 0;

  const getLocalisedTotal: (numberTotal: number) => string = (
    numberTotal: number,
  ) => formatNumberToCurrency(numberTotal, currency, currentLang);

  const balanceHelperText = isSupplementaryPaymentRequired
    ? `${translate(
        'RestaurantVoucher_balanceOutstanding_supplementaryPayment',
      )}`
    : `${translate(
        'RestaurantVoucher_balanceOutstanding_noSupplementaryPayment',
      )}`;

  return (
    <SectionItem
      className={classes.balanceSection}
      label={`${translate('RestaurantVoucher_balanceOutstanding')}`}
      rightHeader={
        <PriceTag
          className={classes.balanceTotal}
          localisedPrice={getLocalisedTotal(balanceOutstanding)}
          translate={translate}
        />
      }
    >
      <Typography className={classes.balanceHelperText} variant="body2">
        {balanceHelperText}
      </Typography>
    </SectionItem>
  );
}
